import { I18nLocale } from '#/i18n/types/I18nLocale';
import { IDEALIST_DAYS_PATH } from '#/layouts/Layout/Header/layoutHeaderConstants';
import { searchGetInternshipsPath } from '#/modules/search/internships/routing/searchGetInternshipsPath';
import { searchGetJobsPath } from '#/modules/search/jobs/routing/searchGetJobsPath';
import { searchGetOrgsPath } from '#/modules/search/orgs/routing/searchGetOrgsPath';
import { searchGetVolopsPath } from '#/modules/search/volops/routing/searchGetVolopsPath';
import { SIGN_UP_TO_POST_URL_FOR_LOCALE } from '#/routing/route-constants';
import { createOrgPath, postAListingPath } from '#/routing/routes';

import type { HamburgerMenuData } from './types/HamburgerMenuData';

// CREATE rows with loggedOutHref point to SIGN_UP_TO_POST_URL_FOR_LOCALE when
// there is no user; href is the logged-in target.
export const hamburgerMenuDataEn: HamburgerMenuData = {
  sections: [
    {
      type: 'explore',
      title: 'Explore',
      rows: [
        {
          type: 'get-involved',
          title: 'Get Involved',
          href: IDEALIST_DAYS_PATH[I18nLocale.EN],
        },
        {
          type: 'job',
          title: 'Find a Job',
          href: searchGetJobsPath({
            locale: I18nLocale.EN,
            embedSearchWidgetId: null,
          }),
        },
        {
          type: 'volop',
          title: 'Find Volunteer Opportunities',
          href: searchGetVolopsPath({
            locale: I18nLocale.EN,
            embedSearchWidgetId: null,
          }),
        },
        {
          type: 'internship',
          title: 'Find an Internship',
          href: searchGetInternshipsPath({ locale: I18nLocale.EN }),
        },
        {
          type: 'org',
          title: 'Search Organizations',
          href: searchGetOrgsPath({ locale: I18nLocale.EN }),
        },
        {
          type: 'resources',
          title: 'Resources',
          rows: [
            {
              type: 'career-advice',
              title: 'Career Advice',
              href: '/en/careers',
            },
            {
              type: 'volunteer-resources',
              title: 'Volunteer Resources',
              href: '/en/volunteering-resources?pq=',
            },
            {
              type: 'salary-explorer',
              title: 'Nonprofit Salary Explorer',
              href: '/nonprofit-salary-explorer',
            },
            {
              type: 'recipes-for-action',
              title: 'Recipes for Action',
              href: '/en/recipes-for-action?pq=',
            },
            {
              type: 'employer-resources',
              title: 'Employer Resources',
              href: '/en/orgs/resources',
            },
            {
              type: 'volunteer-engagement-resources',
              title: 'Volunteer Engagement Resources',
              href: '/en/orgs/volunteer-engagement-resources',
            },
          ],
        },
        {
          type: 'business-solutions',
          title: 'Business Solutions',
          // NOTE: we're forcing <a> links, see similar ApiAndIntegrationsDropdown (sc-66910)
          rows: [
            {
              type: 'api',
              title: 'API',
              href: '/en/open-network-api',
              fullPageReload: true,
            },
            {
              type: 'search-module',
              title: 'Search Module',
              href: '/volunteer-search-widget',
              fullPageReload: true,
            },
            {
              type: 'volunteer-engagement-pages',
              title: 'Volunteer Engagement Pages',
              href: '/en/volunteer-engagement-pages',
              fullPageReload: true,
            },
            {
              type: 'csr-partners',
              title: 'CSR Partners',
              href: '/csr-services',
              fullPageReload: true,
            },
          ],
        },
      ],
    },
    {
      type: 'create',
      title: 'Create',
      rows: [
        {
          type: 'post-a-listing',
          title: 'Post a Listing',
          href: postAListingPath.with({}),
          loggedOutHref: SIGN_UP_TO_POST_URL_FOR_LOCALE.en,
        },
        {
          type: 'create-org',
          title: 'Create an Organization',
          href: createOrgPath.with({}),
          loggedOutHref: SIGN_UP_TO_POST_URL_FOR_LOCALE.en,
        },
      ],
    },
  ],
  accountSectionTitle: 'Account',
  myAccountSectionTitle: 'My Account',
  organizationSectionTitle: 'Organization',
  organizationsSectionTitle: 'Organizations',
};
